import { gql } from '@apollo/client'

export const MODIFY_RESERVE_TA_PANEL_MUTATION = gql`
  mutation ModifyReserveTAPanel(
    $input: RoomModifyReserveInput!
    $dryRun: Int!
    $reservationNumber: String!
  ) {
    modifyReserveTAPanel(
      input: $input
      dryRun: $dryRun
      reservationNumber: $reservationNumber
    ) {
      CRSNumber
      description
      info {
        ratePlanCode
        roomTypeCode
        originalAmount
        originalAmountBeforeDiscount
        currentAmount
        currentAmountBeforeDiscount
        currentAmountExtraBed
        currentAmountExtraBedBeforeDiscount
        currency
        penalty
        promotionDropped
      }
      reservationNumber
      status
    }
  }
`
export const CONFIRM_MODIFICATION_TA_PANEL_MUTATION = gql`
  mutation ConfirmModificationTAPanel(
    $reservationNumber: String!
    $roomReservationNumber: String!
  ) {
    confirmModificationTAPanel(
      reservationNumber: $reservationNumber
      roomReservationNumber: $roomReservationNumber
    ) {
      CRSNumber
      description
      info {
        ratePlanCode
        roomTypeCode
        originalAmount
        originalAmountBeforeDiscount
        currentAmount
        currentAmountBeforeDiscount
        currentAmountExtraBed
        currentAmountExtraBedBeforeDiscount
        currency
        penalty
      }
      reservationNumber
      status
    }
  }
`
